import pagination from "./pagination";
export default pagination;
